export default __webpack_public_path__ + "static/Quickinstallation_Tile_9008_Step_10-5a163d61838f9d6f3c4b0661a7e7bce0.webp";